import React from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { AlarmRounded } from "@mui/icons-material";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

function SuccessPage({ handleCloseDialog }) {
  return (
    <Box sx={{ textAlign: "center", mb: 4 }}>
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          bgcolor: "success.lighter",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 24px",
        }}
      >
        <CheckCircleRoundedIcon sx={{ fontSize: 60, color: "success.main" }} />
      </Box>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
        Richiesta Inviata con Successo! 🎉
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Grazie per aver scelto EnergyCompare. Un nostro consulente ti contatterà
        al più presto per proporti le migliori offerte.
      </Typography>

      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: "info.lighter",
              borderRadius: 2,
              border: 1,
              borderColor: "info.light",
              textAlign: "center",
            }}
          >
            <AlarmRounded sx={{ fontSize: 40, color: "info.main", mb: 1 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
              Tempi di risposta
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ti contatteremo entro 24 ore lavorative
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: "secondary.lighter",
              borderRadius: 2,
              border: 1,
              borderColor: "secondary.light",
              textAlign: "center",
            }}
          >
            <PhoneRoundedIcon
              sx={{ fontSize: 40, color: "secondary.main", mb: 1 }}
            />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
              Hai urgenza?
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "secondary.main", fontWeight: 600 }}
            >
              Chiamaci: 02 2001390
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          bgcolor: "background.default",
          borderRadius: 2,
          textAlign: "left",
          mb: 4,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <DescriptionRoundedIcon sx={{ color: "primary.main" }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Prossimi passi:
          </Typography>
        </Box>
        <Stack spacing={2}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: "success.main",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              1
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Analizzeremo il tuo profilo di consumo
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: "primary.main",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              2
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Confronteremo le offerte di oltre 35 operatori
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: "warning.main",
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              3
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Ti proporremo le 3 offerte più vantaggiose
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Paper>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 3,
        }}
      >
        {[1, 2, 3, 4, 5].map((star) => (
          <Box
            key={star}
            component="span"
            sx={{ color: "warning.main", fontSize: 24 }}
          >
            ⭐
          </Box>
        ))}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 600 }}>
          4.8/5 su 2.547 recensioni
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="large"
        onClick={handleCloseDialog}
        endIcon={<ArrowForwardRoundedIcon />}
        sx={{ minWidth: 200 }}
      >
        Torna alla Home
      </Button>
    </Box>
  );
}

export default SuccessPage;
